/** Typed health endpoint contract. Mirrors ``backend/app/api/v1/health.py``. */
import { http } from "@/shared/api/http";

export type AdapterStatus =
  | "ok"
  | "mock"
  | "noop"
  | "local"
  | "stub"
  | "down";

export interface AdapterMatrix {
  ai: AdapterStatus;
  storage: AdapterStatus;
  email: AdapterStatus;
  social: AdapterStatus;
  auth: AdapterStatus;
}

export interface HealthResponse {
  status: "ok" | "degraded";
  version: string;
  milestone: string;
  environment: string;
  uptime_seconds: number;
  db: "ok" | "down";
  adapters: AdapterMatrix;
  prompts_loaded: number;
  correlation_id: string | null;
}

export interface VersionResponse {
  version: string;
  milestone: string;
  blueprint: string;
  environment: string;
}

export const fetchHealth = (): Promise<HealthResponse> =>
  http<HealthResponse>("/health/internal");

export const fetchVersion = (): Promise<VersionResponse> =>
  http<VersionResponse>("/version");
